import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-product-settings',
  templateUrl: './product-settings.component.html',
  styleUrls: ['./product-settings.component.css']
})
export class ProductSettingsComponent implements OnInit {
    public itemsListProductSettings: Item[] = [];

    constructor(private datatask: DataTaskService) {

    }

    private async loadProductSettings() {
        this.itemsListProductSettings = await this.datatask.Post(673);
    }

    private async init() {
        this.loadProductSettings();
    }

    ngOnInit() {
        this.init();
    }
}
